module.exports = __webpack_public_path__ + "static/media/5.5b6f9fa3.png";